<template>
  <div class="basic-group-info mt-4">
    <b-form-group>
      <div v-if="teachers.length">
        <b-col>
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="filteredResults"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-btn
                  :disabled="!filteredResults"
                  @click="filteredResults = ''"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          v-cloak
          responsive
          :fields="searchResultsFields"
          :items="teachers"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filteredResults"
          @filtered="onFiltered"
        >
          <template slot="cell(first_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditTeacher', params: { id: row.item.tuuid } }"
              >{{ row.item.teacher_name }}</b-link
            >
            <br />
            <p class="small-date">country: {{ row.item.country }}</p>
            <p class="small-date">district: {{ row.item.region }}</p>
          </template>
          <template slot="cell(sex)" slot-scope="row">{{
            row.item.sex === "male" ? "M" : "F"
          }}</template>
          <template slot="cell(id)" slot-scope="row">
            <b-link class="add" @click.stop="setTeacher(row.item)">ADD</b-link>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="teachers.length || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "GroupTeacher",
  props: {
    parent: String,
  },
  data() {
    return {
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" },
      ],
      currentPage: 1,
      perPage: 3,
      filteredResults: null,
    };
  },
  methods: {
    ...mapActions({
      GET_TEACHERS: "teachers/GET_TEACHERS",
      ADD_TEACHER: "groups/ADD_TEACHER",
      GET_GROUP_TEACHERS: "groups/GET_GROUP_TEACHERS",
    }),
    stopClick() {},
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async setTeacher(item) {
      const teachersIds = [...this.$store.state.groups.group.teachers];
      if (teachersIds.includes(item.tuuid)) {
        return;
      }

      const teachersNames = [...this.$store.state.groups.group.teacher_names];
      teachersIds.push(item.tuuid);
      teachersNames.push(item.teacher_name);
      this.$store.commit("groups/teachers", teachersIds);
      this.$store.commit("groups/teacher_names", teachersNames);

      if (!this.add) {
        await this.ADD_TEACHER({ id: item.tuuid });
        await this.GET_GROUP_TEACHERS();
      }
    },
  },
  computed: {
    add() {
      return this.$route.path.includes("/add") ? true : false;
    },
    teachers: {
      get() {
        return this.$store.state.teachers.teachers;
      },
    },
    group_teacher: {
      get() {
        return this.$store.state.groups.group.group_teacher;
      },
    },
    teacher_name: {
      get() {
        return this.$store.state.groups.group.teacher_name;
      },
    },
  },
  mounted() {
    this.GET_TEACHERS();
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
